import axios from "axios"

const CHUNK_SIZE = 1024 * 1024

// const AUTH_KEY = user = JSON.parse(localStorage.getItem("auth") || '{}')
// const header = {
//     headers: {
//         Authorization: `Bearer ${AUTH_KEY}`
//     }
// }
const getToken = () => {
    let user = JSON.parse(localStorage.getItem("auth") || '{}')
    if (user?.token) {
        return {
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        }
    }
    return {}
}
export async function generateHash(file) {

    const buffer = await file.arrayBuffer()

    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer)

    const hashArray = Array.from(new Uint8Array(hashBuffer))

    return hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
}

export async function uploadFile(file, updateProgress, commit = {}) {

    try {
        const hash = await generateHash(file)
        const check = await axios.post("https://repo.plakal.in/api/check-file/", {
            hash,
            ...commit

        }, getToken())

        console.log("FILE UPLOAD:", check.data)
        if (check.data.exists) {
            return "File already uploaded"
        }

        const totalChunks = Math.ceil(file.size / CHUNK_SIZE)

        const status = await axios.get("https://repo.plakal.in/api/upload-status/", {
            params: { hash },
            headers: getToken().headers
        })

        let uploadedChunks = status.data.uploaded_chunks

        const startTime = Date.now()

        for (let i = 0; i < totalChunks; i++) {

            if (uploadedChunks.includes(i)) {
                continue
            }

            const start = i * CHUNK_SIZE
            const chunk = file.slice(start, start + CHUNK_SIZE)

            const formData = new FormData()

            formData.append("file", chunk)
            formData.append("chunkIndex", i)
            formData.append("totalChunks", totalChunks)
            formData.append("filename", file.name)
            formData.append("hash", hash)
            Object.keys(commit).map((com) => {
                formData.append(com, commit[com])
            })

            await axios.post("https://repo.plakal.in/api/upload-chunk/", formData,
                //header
                getToken()
            )

            const percent = Math.round(((i + 1) / totalChunks) * 100)

            const uploaded = (i + 1) * CHUNK_SIZE
            const elapsed = (Date.now() - startTime) / 1000

            const speed = uploaded / elapsed
            const remaining = (file.size - uploaded) / speed

            updateProgress(percent, speed, remaining)
        }
    } catch (error) {
        console.log("RESPONSE ERROR", error.response.data.error)
        return error?.response?.data?.error
    }
}